var youbora = require('youboralib')
var manifest = require('../../manifest.json')

youbora.adapters.Bitmovin = youbora.StandardAdapter.extend({
  getVersion: function () {
    return manifest.version + '-' + manifest.name + '-' + manifest.tech
  },

  getDuration: function () {
    return this.duration
  },

  getPosition: function () {
    return this.plugin.getAdapter().flags.isJoined ? 'mid' : 'pre'
  },

  getListenersList: function () {
    var EVENT = this.player.EVENT || bitmovin.player.EVENT
    return [{
      suscriber: 'addEventHandler',
      unsuscriber: 'removeEventHandler',
      events: {
        [EVENT.ON_AD_CLICKED]: this.clickListener,
        [EVENT.ON_AD_ERROR]: this.errorListener,
        [EVENT.ON_AD_FINISHED]: this.endListener,
        [EVENT.ON_AD_LINEARITY_CHANGED]: null,
        [EVENT.ON_AD_MANIFEST_LOADED]: this.manifestListener,
        [EVENT.ON_AD_PLAYBACK_FINISHED]: this.endListener,
        [EVENT.ON_AD_SCHEDULED]: null,
        [EVENT.ON_AD_SKIPPED]: this.skipListener,
        [EVENT.ON_AD_STARTED]: this.joinListener,
        [EVENT.ON_AD_BREAK_FINISHED]: this.endListener,
        [EVENT.ON_AD_BREAK_STARTED]: this.playListener,
        [EVENT.ON_AD_QUARTILE]: this.quartileListener,
        [EVENT.ON_PAUSED]: this.pauseListener,
        [EVENT.ON_PLAYING]: this.playingListener
      }
    }]
  },

  playListener: function (e) {
    this.fireStart()
    this.fireResume()
  },

  pauseListener: function (e) {
    this.firePause()
  },

  playingListener: function (e) {
    this.fireResume()
  },

  joinListener: function (e) {
    this.duration = e.duration
    this.fireStart()
    this.fireJoin()
  },

  clickListener: function (e) {
    this.fireClick(e.clickThroughUrl)
  },

  endListener: function (e) {
    this.fireStop()
    this.duration = null
  },

  errorListener: function (e) {
    // 200, 303, 403, 404, 405, 900, 901 Advertisement
    if (e.code >= 200 && e.code <= 999) {
      this.fireError(e.code, e.message)
      this.fireStop()
      this.duration = null
    }
  },

  skipListener: function (e) {
    this.fireSkip()
    this.duration = null
  },

  manifestListener: function (e) {
    youbora.Log.error(e)
  },

  /*quartileListener: function (e) {
    var quartileNumber = 1
    if (e.quartile === "midpoint") {
      quartileNumber = 2
    } else if (e.quartile === "thirdQuartile") {
      quartileNumber = 3
    }
    this.fireQuartile(quartileNumber)
  }*/

})

module.exports = youbora.adapters.Bitmovin
